import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import ComparableWrapper from 'agency/digital_renderer/components/ComparableWrapper'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'
import styles from './styles.scss'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterComparables = (comparables, filters) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit ? comparables.slice(filterOffset, filterLimit) : comparables.slice(filterOffset)

  return limited
}

const renderComparables = (comparables, comparableContainer) => comparables.map(comparable => (
  <div className={styles.comparable} key={comparable.id} style={deviceStyle(comparableContainer)}>
    <ElementContainer
      forwardContextToItems={comparable}
      section={comparableContainer}
      renderNested
      render={({ itemComponents }) => itemComponents.map(component => component)}
    />
  </div>
))

const Comparables = (props) => {
  const {
    callbacks: { registerActiveComponent },
    data,
    items,
    options,
  } = props

  const { shortcode } = data || {}

  const {
    comparableSource, comparableStatus, limit, offset,
  } = options || {}

  const comparableContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { activeComponents, campaign } = defaultContext

  return (
    <ComparableWrapper
      campaign={campaign}
      comparableSource={comparableSource || null}
      comparableStatus={comparableStatus || ''}
      render={({ comparables }) => {
        const filtered = filterComparables(comparables, { limit, offset })
        if (!filtered.length) return null

        if (shortcode && !activeComponents[shortcode]){
          registerActiveComponent(shortcode, { count: filtered.length })
        }

        return (
          <AnimationWrapper options={options}>
            <div className={styles.root} style={style}>
              {renderComparables(filtered, comparableContainer)}
            </div>
          </AnimationWrapper>
        )
      }}
    />
  )
}

Comparables.propTypes = {
  callbacks: PropTypes.shape({
    registerActiveComponent: PropTypes.func.isRequired,
  }),
  data: PropTypes.object,
  items: PropTypes.array,
  options: PropTypes.object,
}

export default Comparables
